import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid";

const FormInput = ({
  label,
  name,
  value = "",
  onChange,
  placeholder,
  type = "text",
  required = false,
  error,
  additionalClass = "",
  prefix = null,
  icon = null,
  onFocus = () => {},
  showRequiredOrOptional = true,
  maxLength = 400,
  showMaxLength = false,
  max = null,
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="mb-2">
      {/* Label */}
      <label className="block text-sm font-medium text-primary">
        {label}{" "}
        {required && showRequiredOrOptional && (
          <span className="text-muted">{t("modal.required")}</span>
        )}
        {!required && showRequiredOrOptional && (
          <span className="text-muted">{t("modal.optional")}</span>
        )}
      </label>

      {/* Input avec icône et compteur interne */}
      <div className="relative">
        {icon && (
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500 pointer-events-none">
            {icon}
          </span>
        )}
        <input
          type={type === "password" && showPassword ? "text" : type}
          name={name}
          autoComplete="off"
          value={value}
          maxLength={maxLength}
          onChange={(e) => onChange(name, e.target.value)}
          onFocus={(e) => onFocus(e)}
          placeholder={placeholder}
          required={required}
          max={max !== null ? max : undefined}
          className={`w-full border text-primary ${
            error ? "border-red-500" : "border-gray-300"
          } rounded-lg px-4 py-3 pr-16 ${
            icon ? "pl-10" : ""
          } focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary ${additionalClass}`}
        />

        {/* Compteur à l'intérieur du champ */}
        {maxLength && showMaxLength && (
          <span className="absolute inset-y-0 right-3 flex items-center text-gray-400 text-sm">
            {value.length} / {maxLength}
          </span>
        )}

        {/* Icône pour le champ mot de passe */}
        {type === "password" && (
          <span
            className="absolute inset-y-0 right-8 flex items-center pr-3 text-gray-500 cursor-pointer"
            onClick={handleTogglePassword}
          >
            {!showPassword ? (
              <EyeSlashIcon className="w-5 h-5" />
            ) : (
              <EyeIcon className="w-5 h-5" />
            )}
          </span>
        )}
      </div>

      {/* Gestion des erreurs */}
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default FormInput;
